import React, { useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { useQuery } from 'react-query';
import moment from "moment";
import { useClient } from "../../Context/ClientContext";
import { useUser } from "../../Context/UserContext";
import { DeleteUserByContact, getUserByClient } from "../../Data/user_service";
import { ProgressSpinner } from 'primereact/progressspinner';
import "./Pagination.css"
import Pagination from "./Pagination";
export default function CltUtser() {
  // const [cltUsers, setCltUsers] = useState();
  // const [cltUser, setCltUser] = useState();
  const {selectedClient}=useClient()
  const {setUserList , users , setSelectedUser , user , selectedUser }=useUser()
  const [globalFilter, setGlobalFilter] = useState();
  const [searchText, setSearchText] = useState(""); // Search text input
  const [filteredUsers, setFilteredUsers] = useState([]); // Filtered users list  
  const [deleteDialog, setDeleteDialog] = useState();
  const [usersList, setUsersList] = useState(false);
   const toast = useRef(null);
  const dt = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  //const dataPerPage = 10;
  const [dataPerPage, setDataPerPage] = useState(100);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
 
  
  const totalPages = Math.ceil((filteredUsers?.length || 0) / dataPerPage);
  const lastIndex = currentPage * dataPerPage;
  const firstIndex = lastIndex - dataPerPage;
  const currentData = filteredUsers?.slice(firstIndex, lastIndex) || [];
  const { refetch } =useQuery('UsersList',()=> getUserByClient(setUserList), {
    refetchOnWindowFocus: true,
    cacheTime: 1000,
    refetchInactive:true,
    onSuccess: () => 
      // This will be called after successful refetch
      setUserList([]),
    
  
 });
 

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);

    if (value.trim() === "") {
      setFilteredUsers(Object.values(users)); // Réinitialisation si le champ est vide
    } else {
      const filtered = Object.values(users).filter(
        (user) =>
          user.nom.toLowerCase().includes(value.toLowerCase()) ||
          user.prenom.toLowerCase().includes(value.toLowerCase()) ||
          user.email.toLowerCase().includes(value.toLowerCase()) ||
          user.id_utilisateur_gexonline.toString().toLowerCase().includes(value.toLowerCase())
      );
      setFilteredUsers(filtered); // Mise à jour avec les résultats filtrés
    }
  };

  useEffect(() => {
    const userArray = Object.values(users);
    setUsersList(userArray);
    setFilteredUsers(userArray); // Initialize with all users
  }, [users]);
  
 useEffect(() => {
  refetch();
 }, [ refetch ]);

 useEffect(() => {
  
 const UserByClient = Object.values(users)
  setUsersList(UserByClient)
  
 }, [users , setUsersList , selectedClient ]);

  const header = (
    <div className="table-header">
      <h5 className="mx-0 my-1">Liste des clients-utilisateurs </h5>
      <span className="p-input-icon-right">
        <InputText
          type="search"
          value={searchText}
          onChange={handleSearchChange}
          placeholder=" Chercher..."
        />
        <i className="pi pi-search" />
      </span>
    </div>
  );
  const confirmDelete = (clientUser) => {
    setSelectedUser(clientUser);
    setDeleteDialog(true);
  };
  const deleteClient = () => {
 
    const utilisateurId =selectedUser.id_utilisateur_gexonline;
     DeleteUserByContact(utilisateurId ,setSelectedUser)
    .then(()=> {
      setDeleteDialog(false);
      refetch();
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Utilisateur supprimé",
        life: 3000,
      });
    })
   
   
  };
  const deleteDialogFooter = (
    <React.Fragment>
      <Button
        label="Non"
        icon="pi pi-times"
        className="p-button-text"
        onClick={() => setDeleteDialog(false)}
      />
      <Button
        label="Oui"
        icon="pi pi-check"
        className="p-button-text"
        onClick={deleteClient}
      />
    </React.Fragment>
  );

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
      
        <Button
          icon="pi pi-trash"
          className="p-button-rounded succesBtn"
          onClick={() => confirmDelete(rowData)}
        />
        
      </React.Fragment>
    );
  };
  const creadtedByGexonline = (rowData) => {
    const gex = rowData.created_by_gexonline;
    // return gex;
    return String(gex);
  };
  const date_octroi=(rowData)=> {
    
    const date= rowData.date_octroi_role
     if (date)
        return moment(date).format("DD/MM/YYYY")
      else return ""
  }
  const date_enrgistrement=(rowData)=> {
   
    const date= rowData.date_finalisation_enregistrement
     if (date)
        return moment(date).format("DD/MM/YYYY")
      else return ""
  }
  return (
    <div className="datatable-crud ">
      <Toast ref={toast} />
      
      <DataTable
        ref={dt}
        value={currentData}
        dataKey="id"
        globalFilter={globalFilter}
        header={header}
        responsiveLayout="scroll"
        className="crudTable"
        scrollable 
         scrollHeight="500px" 
         emptyMessage={ <span>Pas d'utilisateur</span>} // Message when no users are available
      
      >
        <Column
          field="id_utilisateur_gexonline"
          header="ID Utilisateur"
          style={{width: "3rem" }}
          body={(rowData) => (
            <div className="table-data">
            <span className="mobile-header">ID Utilisateur </span>{rowData.id_utilisateur_gexonline}
            </div>
          )}
        ></Column>
         <Column
          field="prenom"
          header="Prénom"
          style={{ minwidth: "4rem" }}
          body={(rowData) => (
            <div className="table-data">
            <span className="mobile-header">Prenom </span>{rowData.prenom}
            </div>
          )}
        ></Column>
        <Column
          field="nom"
          header="Nom"
          style={{ width: "4rem" }}
          body={(rowData) => (
            <div className="table-data">
            <span className="mobile-header">Nom </span>{rowData.nom}
            </div>
          )}
        ></Column>
       
        <Column
          field="email"
          header="Email"
          style={{ minWidth: "23rem" }}
          body={(rowData) => (
            <div className="table-data">
            <span className="mobile-header">Email </span>{rowData.email}
            </div>
          )}
        ></Column>
        <Column
          field="role"
          header="Rôle"
          style={{ minWidth: "10rem" }}
          body={(rowData) => (
            <div className="table-data">
            <span className="mobile-header">Rôle </span>{rowData.role}
            </div>
          )}
        ></Column>
        <Column
          
          
          header="Crée par gexonline"
          style={{ width: "10rem"}}
          body={(rowData) => (
            <div className="table-data">
            <span className="mobile-header">Crée par gexonline </span>{creadtedByGexonline(rowData)}
            </div>
          )}
        ></Column>
       <Column 
       
      
       header ="Date octroi role" 
       style={{ minWidth: "15rem" }}
       body={(rowData) => (
        <div className="table-data">
        <span className="mobile-header">Date octroi role </span>{date_octroi(rowData)}
        </div>
      )}>

       </Column>
       {/*<Column 
       
       body={date_enrgistrement}
       header ="date de finalisation d'enregistrement" 
       style={{ minWidth: "15rem" }}>
     </Column>*/}
       {/* <Column 
       field="lastseenconnexion" 
       header ="la dernière connexion" 
       style={{ minWidth: "15rem" }}>
     </Column> */}
       {/*<Column 
       field="data_password_changed" 
       header ="la date de changement de mot de passe" 
       style={{ minWidth: "15rem" }}>
     </Column>*/}
       <Column 
       field="added_by" 
       header ="Ajouté par" 
       style={{ minWidth: "15rem"  }}
       body={(rowData) => (
        <div className="table-data">
        <span className="mobile-header">Ajouté par </span>{rowData.added_by}
        </div>
      )}>

       </Column>
       <Column
          field="id_client_gexpertise"
          header="ID Clients"
          style={{ minWidth: "8rem" }}
          body={(rowData) => (
            <div className="table-data">
            <span className="mobile-header">ID Clients </span>{rowData.id_client_gexpertise}
            </div>
          )}
          
        ></Column>

      
        
        <Column
          body={actionBodyTemplate}
          exportable={false}
          header="Actions"
          style={{ minWidth: "10rem" }}
        ></Column>
      </DataTable>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        dataPerPage={dataPerPage}
        setDataPerPage={setDataPerPage}
        handlePageChange={handlePageChange}
      />
      
      <Dialog
        visible={deleteDialog}
        style={{ width: "450px" }}
        header="Confirm"
        modal
        footer={deleteDialogFooter}
        onHide={() => setDeleteDialog(false)}
      >
        <div className="confirmation-content">
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {usersList && (
            <span>
            Voulez-Vous supprimer <b>{selectedUser.nom}</b>?
            </span>
          )}
        </div>
      </Dialog>
      {/* <Dialog
        visible={editDialog}
        style={{ width: "450px" }}
        header="Confirm"
        modal
        className="p-fluid"
        footer={EditDialogFooter}
        onHide={() => setEditDialog(false)}
      >
        {cltUser && (
          <div>
            <div className="field">
              <label htmlFor="idClient">id Client</label>
              <InputText
                id="idClient"
                value={cltUser.clientId}
                // onChange={(e) => onInputChange(e, 'idClientGexpertise')}
                disabled
                required
              />
            </div>

            <div className="field">
              <label htmlFor="name">id utilisateur</label>
              <InputText
                id="idClientGexpertise"
                value={cltUser.utilisateurId}
                // onChange={(e) => onInputChange(e, "nom")}
                required
                
                className={classNames({
                  "p-invalid": submitted && !cltUser.utilisateurId,
                })}
              />
              {submitted && !cltUser.utilisateurId && (
                <small className="p-error">
                  l'identifiant utilisateur requis.
                </small>
              )}
            </div>
            <div className="field">
              <label htmlFor="name">role</label>
              <InputText
                id="role"
                value={cltUser.role}
                // onChange={(e) => onInputChange(e, "nom")}
              />
            </div>

            <div className="field">
              <label className="mb-3">Crée par gexonline</label>
              <div className="formgrid grid">
                <div className="field-radiobutton col-6">
                  <SelectButton
                    value={String(cltUser.createdByGexonline)}
                    // onChange={onArchiveChange}
                    options={options}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </Dialog> */}
    </div>
  );
}